import { useBillingTypeMappingVM } from "presentation/hook/BillingTypeMapping/useBillingTypeMappingVM";
import { useBillingTypeMappingTracked } from "presentation/store/BillingTypeMapping/BillingTypeMappingProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import BillingTypeMappingTitleBar from "./BillingTypeMappingTitleBar";
import BillingTypeMappingEditPanel from "./RightPanel/BillingTypeMappingEditPanel";
import BillingTypeMappingTablePanel from "./Table/BillingTypeMappingTablePanel";


const BillingTypeMappingMaintenance: React.FC = () => {
    const [billingTypeMappingState] = useBillingTypeMappingTracked();
    const [isLoading, setIsLoading] = useState(true);
    const billingTypeMappingVM = useBillingTypeMappingVM();
    const { isShowEditPanel } = billingTypeMappingState;


    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    billingTypeMappingVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            billingTypeMappingVM.searchAllBillingTypeMappingList().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }).catch(error => {
            setIsLoading(false)
        });

    }, [billingTypeMappingVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>

            {!(isShowEditPanel) && <>
                <BillingTypeMappingTitleBar />
                <BillingTypeMappingTablePanel /></>}
            {(isShowEditPanel) &&
                <SliderPanel
                    isOpen={true}
                    draggable={false}
                    leftSectionWidth={"100%"}
                    rightSectionWidth={"0%"}
                    leftChildren={<BillingTypeMappingEditPanel />}
                />}
        </div>
    </>
}

export default memo(BillingTypeMappingMaintenance);